import { omit } from 'lodash';
import { logEvent } from '../helpers/analytics';
import { getGrade } from '../components/charts/LetterScore';

export const initialState = {
  isRunning: false,
  scores: null,
  results: null,
  initial_take_home_pay: null,
};

export const gradeAnalytics = (score, value) => {
  const grade = getGrade(value * 100);
  return {
    [`${score}_grade`]: grade.letter,
    [`${score}_grade_letter`]: grade.letter.split('')[0],
  };
};

export function simReducer(prefix = '', excludeKeys = []) {
  return function reducer(state = initialState, action) {
    switch (action.type) {
      case `${prefix}SIMULATION_STARTED`:
        return Object.assign({}, state, {
          isRunning: true,
        });
      case `${prefix}SIMULATION_MOVED_TO_PERMANENT`:
      case `${prefix}SIMULATION_FINISHED`:
        logEvent('SimulationResult', {
          ...action.payload.scores,
          ...gradeAnalytics('lifestyle_spending_score', action.payload.scores.lifestyle_spending_score),
          ...gradeAnalytics('plan_consistency', action.payload.scores.plan_consistency),
          ...gradeAnalytics('readiness_grade', action.payload.scores.plan_consistency),
        });
        return Object.assign({}, state, {
          isRunning: false,
          results: omit(action.payload, excludeKeys),
        });
      default:
        return state;
    }
  };
}

export default simReducer('');
